import React, { useState, useEffect, useContext } from 'react';
import styles from "../../styles/pages/AllowedIps/AllowedIpsPage.module.css"; 
import { getContactUsApi } from '../../utils/api/ContactUs/getContactUsApi';
import { LoadingCircle } from '../../components/UI/Custom/LoadingCircle';
import { LangContext } from '../../context/LangContext';
import { ThemeContext } from '../../context/ThemeContext';
import { Title } from '../../components/UI/Custom/Title';
import { formatDateTime } from '../../utils/custom/formatters';

const translations = {
    ru: {
        title: 'Запросы Contact Us',
        id: 'ID',
        name: 'Имя',
        phone: 'Телефон',
        message: 'Сообщение',
        createdAt: 'Дата создания',
        emptyList: 'Список запросов пуст.',
        page: 'Страница'
    },
    en: {
        title: 'Contact Us Requests',
        id: 'ID',
        name: 'Name',
        phone: 'Phone',
        message: 'Message',
        createdAt: 'Creation Date',
        emptyList: 'Request list is empty.',
        page: 'Page'
    }
};

export const ContactUsPage = () => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';
    const t = translations[langSelected] || translations.ru;

    const [requests, setRequests] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, per_page: 15, total: 0, last_page: 1 });

    const loadRequests = async (currentPage = 1) => {
        setIsLoading(true);
        try {
            const response = await getContactUsApi(currentPage, pagination.per_page);
            setRequests(response.data);
            setPagination({
                page: response.meta.current_page,
                per_page: response.meta.per_page,
                total: response.meta.total,
                last_page: response.meta.last_page
            });
        } catch (error) {
            console.error('Error loading Contact Us:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadRequests();
    }, []);

    const handlePageChange = (newPage) => {
        loadRequests(newPage);
    };

    if (isLoading) {
        return (
            <div className={`${styles.loadingBlock} ${isDark ? styles.darkLoadingBlock : ''}`}>
                <LoadingCircle isDark={isDark} />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <Title h2={t.title} activeSpan={true} />

            <div className={`${styles.content} ${isDark ? styles.darkContent : ''}`}>
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        <thead className={`${styles.tableHeader} ${isDark ? styles.darkTableHeader : ''}`}>
                            <tr>
                                <th>{t.id}</th>
                                <th>{t.name}</th>
                                <th>{t.phone}</th>
                                <th>{t.message}</th>
                                <th>{t.createdAt}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.length > 0 ? (
                                requests.map((item) => (
                                    <tr key={item.id} className={`${styles.tableRow} ${isDark ? styles.darkTableRow : ''}`}>
                                        <td className={`${styles.tableCell} ${isDark ? styles.darkTableCell : ''}`}>{item.id}</td>
                                        <td className={`${styles.tableCell} ${isDark ? styles.darkTableCell : ''}`}>{item.name}</td>
                                        <td className={`${styles.tableCell} ${isDark ? styles.darkTableCell : ''}`}>{item.phone}</td>
                                        <td className={`${styles.tableCell} ${isDark ? styles.darkTableCell : ''}`} style={{ maxWidth: '300px', wordBreak: 'break-word' }}>
                                            {item.message || '-'}
                                        </td>
                                        <td className={`${styles.tableCell} ${isDark ? styles.darkTableCell : ''}`}>
                                            {formatDateTime(item.created_at)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className={`${styles.noLeadsMessage} ${isDark ? styles.darkNoLeadsMessage : ''}`}>
                                        {t.emptyList}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {pagination.last_page > 1 && (
                    <div className={`${styles.pagination} ${isDark ? styles.darkPagination : ''}`}>
                        <div className={styles.pageButtonsWrapper}>
                            <button 
                                className={styles.paginationButton} 
                                disabled={pagination.page === 1}
                                onClick={() => handlePageChange(pagination.page - 1)}
                            >
                                {'<'}
                            </button>
                            <button className={`${styles.paginationButton} ${styles.activePage} ${isDark ? styles.darkActivePage : ''}`}>
                                {pagination.page}
                            </button>
                            <button 
                                className={styles.paginationButton} 
                                disabled={pagination.page === pagination.last_page}
                                onClick={() => handlePageChange(pagination.page + 1)}
                            >
                                {'>'}
                            </button>
                        </div>
                        <p style={{marginLeft: '15px'}}>{t.page} {pagination.page} из {pagination.last_page}</p>
                    </div>
                )}
            </div>
        </div>
    );
};